import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SidenavComponent } from './sidenav/sidenav.component';
import { SidenavContainerComponent } from './sidenav-container/sidenav-container.component';
import { SidenavContentComponent } from './sidenav-content/sidenav-content.component';

@NgModule({
  declarations: [
    SidenavComponent,
    SidenavContainerComponent,
    SidenavContentComponent,
  ],
  imports: [CommonModule],
  exports: [
    SidenavComponent,
    SidenavContainerComponent,
    SidenavContentComponent,
  ],
})
export class SidenavModule {}
